"use strict";

module.exports = function () {
  var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return new Promise(function (resolve) {
    setTimeout(resolve, timeout);
  });
};


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/promise/sleep.js
// module id = 2198
// module chunks = 37